var exports = {
  "kL": "x31de4314--74399e--container",
  "ms": "x31de4314--74399e--advantage-container",
  "kb": "x31de4314--74399e--advantage-icon",
  "GV": "x31de4314--74399e--advantage-text",
};

module.exports = exports;
